import {ReadOnlyTextField} from "components/Shared/ReadOnlyTextField";
import React from "react";
import { CountryReadOnlyField } from 'components/Shared/CountryReadOnlyField'

export function ContractorAddressDetails({address, previousAddress}) {
    return (
        <>
            <ReadOnlyTextField label={'contractor.form.address.street'} value={address?.street}
                               previousValue={previousAddress && {value: previousAddress.value?.street}}/>
            <ReadOnlyTextField label={'contractor.form.address.cityName'} value={address?.cityName}
                               previousValue={previousAddress && {value: previousAddress.value?.cityName}}/>
            <CountryReadOnlyField value={address?.country} label={'contractor.form.address.country'}
                                  previousValue={previousAddress && {value: previousAddress.value?.country}}/>
            <ReadOnlyTextField label={'contractor.form.address.zipCode'} value={address?.zipCode}
                               previousValue={previousAddress && {value: previousAddress.value?.zipCode}}/>
        </>
    )
}